import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';

import { ModalViewLocationService } from '../../../../shared/components/modal-view-location/service/modal-view-location.service';
import { Adresses } from '../../../../shared/components/modal-view-location/components/list-addresses/interfaces/addresses-user.interface';
import { SelectedAddressService } from '../../../../core/service/selected-address.service';
import { Subscription } from 'rxjs';
import { LoaderSubitoService } from '../../../../shared/components/loader-subito/service/loader-subito.service';

@Component({
  selector: 'detail-orden-checkout-informacion-entrega',
  standalone: true,
  imports: [],
  templateUrl: './informacion-entrega.component.html',
  styleUrl: './informacion-entrega.component.css'
})
export class InformacionEntregaComponent implements OnInit, OnDestroy  {
  selectedAddress: Adresses | null = null;
  private addressSubscription: Subscription | null = null;
@Output()
  selectedAddressChange = new EventEmitter<Adresses | null>();
constructor(   public modalViewLocationService: ModalViewLocationService,
  private selectedAddressService: SelectedAddressService,

) { }

ngOnInit(): void {
  this.addressSubscription = this.selectedAddressService.getSelectedAddress().subscribe(address => {
    this.selectedAddress = address;

    this.selectedAddressChange.emit(address);

  });
  const initialAddress = this.selectedAddressService.getCurrentSelectedAddress();
  if (initialAddress) {
    this.selectedAddress = initialAddress;
  }
}

openLocationModal(): void {
  this.modalViewLocationService.toggleModal(true);
}


ngOnDestroy(): void {
  if (this.addressSubscription) {
    this.addressSubscription.unsubscribe();
    this.addressSubscription = null;
  }
}
}
